<div class="d-flex align-items-center justify-content-center vh-100">
  <div class="text-center bg-bg-3 w-100" style="max-width: 500px;">
    <div class="container">
      <div class="p-16 bg-bg-2 justify-content-center">
        <div class="mb-8 fw-bold fs-4 text-primary"><img src="/assets/static/images/finreg-logo.svg" alt="" class="img-fluid"></div>

        <h1 class="text-body-emphasis">{{'pages.signout.goodbye' | translate}}</h1>

        <div class="mt-8">
          <a href="#" class="text-action-2 fw-semibold text-decoration-none" routerLink="/signin">Login</a>
        </div>
      </div>
    </div>
  </div>
</div>
